import { Set as ImmutableSet, List } from 'immutable';
import { OnboardingData } from 'registration/types';

export const ensureStateLicenseSet = (
  stateLicenses: OnboardingData['stateLicenses']
) => {
  if (typeof stateLicenses.first() === 'number') {
    return stateLicenses as ImmutableSet<number>;
  }

  return ImmutableSet(
    (stateLicenses as List<{ state_id: number }>).map((sl) => sl.state_id)
  );
};
